<template>
  <a-card title="Filtros de busca">
    <form ref="form">
      <div class="row-input">
        <div class="opcao">
          <label>Médico</label>
          <input v-model="filters.nomeMedico" type="text" class="ant-input" />
        </div>
        <div class="opcao">
          <label>RG Paciente</label>
          <input v-model="filters.rgPaciente" type="text" class="ant-input" />
        </div>
      </div>
      <div class="row-input">
        <div class="opcao">
          <label>Data da ação</label>
          <input v-model="filters.dtInicio" type="date" class="ant-input" />
          <label>-</label>
          <input v-model="filters.dtFim" type="date" class="ant-input" />
        </div>
      </div>
      <div class="row-input">
        <button class="ant-btn" @click.prevent="searchChamados">Pesquisar</button>
      </div>
    </form>
  </a-card>
  <br />
  <a-card>
    <div class="row-input">
      <div class="opcao">
        <label>Mostrar</label>
        <select v-model="paginationConfig.pageSize">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
        <label>registros</label>
      </div>
    </div>
    <a-table :dataSource="dataChamados.content" :columns="columns" :pagination="paginationConfig">
      <template #horaRegistro="{ record }">
        <span>{{ stringData(record.horaRegistro) }}</span>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { getChamados } from '@/components/service/chamadoService';

export default {
  name: 'PageHistChamados',
  data() {
    return {
      dataChamados: {},
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      filters: {
        nomeMedico: '',
        rgPaciente: '',
        dtInicio: '',
        dtFim: '',
      },
      columns: [
        {
          title: 'Data/Hora',
          dataIndex: 'horaRegistro',
          key: 'horaRegistro',
          // sorter: true,
          slots: { customRender: 'horaRegistro' },
        },
        {
          title: 'Ordem chamada',
          dataIndex: 'ordemChamada',
          key: 'ordemChamada',
        },
        {
          title: 'RG Paciente',
          dataIndex: 'rgPaciente',
          key: 'rgPaciente',
        },
        {
          title: 'Médico',
          dataIndex: 'medico',
          key: 'medico',
        },
        {
          title: 'Sala',
          dataIndex: 'sala',
          key: 'sala',
        },
      ],
    };
  },
  methods: {
    async searchChamados() {
      const queryParams = {
        nomeMedico: this.filters.nomeMedico,
        rgPaciente: this.filters.rgPaciente,
        dtInicio: this.mudaEncodaFormatoData(this.filters.dtInicio),
        dtFim: this.mudaEncodaFormatoData(this.filters.dtFim),
      };

      // Chame getChamados com os parâmetros de consulta
      await getChamados(queryParams).then((res) => {
        this.dataChamados = res.data;
      });
    },
    mudaEncodaFormatoData(dataIngles) {
      if (!dataIngles) {
        return null;
      }
      // Dividir a data em partes (ano, mês, dia)
      const partesData = dataIngles.split('-');

      // Reorganizar as partes da data para o formato desejado (dd/mm/yyyy)
      const dataFormatada = encodeURIComponent(`${partesData[2]}/${partesData[1]}/${partesData[0]}`);

      return dataFormatada;
    },
    stringData(data_str) {
      if (!data_str) {
        return '-';
      }
      const dataCriacao = new Date(data_str);
      dataCriacao.setUTCHours(dataCriacao.getUTCHours() + 3);
      return dataCriacao.toLocaleDateString('pt-BR');
    },
  },
  created() {
    this.searchChamados();
  },
};
</script>

<style scoped>
.row-input {
  display: flex;
  width: 70%;
  justify-content: space-between;
}
.opcao {
  align-items: center;
  margin-right: 1vw;
  display: flex;
}
.opcao * {
  margin: 1vw;
}
.opcao label {
  margin-right: 1vw;
  font-weight: bold;
}
</style>
